import React from "react";
import PropTypes from "prop-types";

const PaginationControls = ({
  pagination,
  onPageChange,
  onPerPageChange,
  pageSizeOptions = [50, 100, 150],
  moduleName = "Items",
}) => {
  const {
    currentPage = 1,
    total = 0,
    perPage = 10,
  } = pagination;

  const totalPages = Math.ceil(total / perPage) || 1;

  const handlePerPageChange = (e) => {
    const newPerPage = parseInt(e.target.value, 10);
    onPerPageChange(newPerPage);
  };

  return (
    <div className="flex justify-between border-t items-center bg-white p-fluid-1">
      {/* Per Page Selector */}
      <div className="flex items-center">
        <span className="mr-2">{moduleName} per page</span>
        <select
          value={perPage}
          onChange={handlePerPageChange}
          className="border-b-2 border-black focus:outline-none"
        >
          {pageSizeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {/* Page Navigation */}
      <div className="flex items-center">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="mx-2 text-gray-500 disabled:opacity-50"
        >
          ❮
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          className="mx-2 text-gray-500 disabled:opacity-50"
        >
          ❯
        </button>
      </div>
    </div>
  );
};

PaginationControls.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    total: PropTypes.number,
    perPage: PropTypes.number,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  moduleName: PropTypes.string,
};

export default PaginationControls;
